import React from "react";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {LeftArrow} from "../../../icons/arrows/left-arrow";
import {RightArrow} from "../../../icons/arrows/right-arrow";
import styles from "../styles/triple-3d-carousel.module.scss";
import classNames from "classnames";

class Triple3dCarouselForwardArrowProps extends BaseProps {
  className: String;
  isRtl: Boolean;
  onClickNext: Function;
}

export const Triple3dCarouselForwardArrow = ((props: Triple3dCarouselForwardArrowProps) => {
  const forwardContainer = {
    className: classNames(styles.arrow_container),
    onClick: () => props.onClickNext()
  };

  return (
    <div {...forwardContainer}>
      {
        props.isRtl ? <LeftArrow /> : <RightArrow />
      }
    </div>
  )
});
